import { EventActionType } from './event-action-type';

export interface SetEventPageTitleAction {
  eventKey: string;
  title: string;
  type: EventActionType.SetEventPageTitle;
}

export const setEventPageTitle = (
  eventKey: string,
  title: string,
): SetEventPageTitleAction => ({
  eventKey,
  title,
  type: EventActionType.SetEventPageTitle,
});
